const namespaceRecommendations = 'ui-recommendations';
const namespaceComparator = "".concat(namespaceRecommendations, "-comparator");
const namespaceCombos = "".concat(namespaceRecommendations, "-combos");
const namespaceCoupon = "".concat(namespaceRecommendations, "-coupon");
export { namespaceCombos, namespaceComparator, namespaceCoupon, namespaceRecommendations };
